(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["temporary-closure-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('McdClosurePopup');
    if (!popup) return;

    const reopeningTime = new Date('2026-10-12T09:00:00-04:00').getTime();
    const dismissedKey = 'mcd-temporary-closure-dismissed';

    if (Date.now() >= reopeningTime || sessionStorage.getItem(dismissedKey) === 'true') return;

    popup.showModal();

    popup.querySelectorAll('[data-mcd-closure-close]').forEach((button) => {
      button.addEventListener('click', () => {
        sessionStorage.setItem(dismissedKey, 'true');
        popup.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
